<script lang="ts">
import LineChart, { type LineDataset } from '../charts/LineChart.svelte'

/** `.cc` wrapper + `LineChart` (quarterly spend, etc.). Title / subtitle: trusted `{@html}`. */
interface Props {
  title: string
  subtitle?: string
  labels: string[]
  datasets: LineDataset[]
  yTickFormat?: (v: number) => string
  tooltipFormat?: (value: number, datasetLabel: string) => string
  maxTicksLimit?: number
  active?: boolean
  height?: string
  cardClass?: string
  cardStyle?: string
}

let {
  title,
  subtitle,
  labels,
  datasets,
  yTickFormat,
  tooltipFormat,
  maxTicksLimit,
  active = false,
  height = '152px',
  cardClass = '',
  cardStyle,
}: Props = $props()
</script>

<div class="cc {cardClass}" style={cardStyle}>
  <div class="ct">{@html title}</div>
  {#if subtitle}
    <div class="cs">{@html subtitle}</div>
  {/if}
  <LineChart {active} {labels} {datasets} {height} {yTickFormat} {tooltipFormat} {maxTicksLimit} />
</div>
